import { inject, Injectable } from '@angular/core';
import { EnvironmentService } from '../environment/environment.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileLogic {
  private environmentService: EnvironmentService = inject(EnvironmentService);

  openLogwienProfile() {
    window.open(this.environmentService.getLogwienProfileUri(), 'logwien_SelfService');
  }
}
